module.exports = __webpack_public_path__ + "static/media/20.ab95b226.jpg";